import React from "react";
import { StepProps } from "../../types";
import { useWebTranslation } from "translations";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { formatErrorMessage } from "utils/validation";
import Gutter from "ui-kit/Gutter";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import UserInfoForm from "components/Signup/components/UserInfoForm/UserInfoFormGer/UserInfoForm";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { upsertDraft } from "components/Signup/store/slices/animals";
import {
  useError,
  useIsLoading,
} from "components/Signup/store/selectors/metadata";

const UserInfo = ({ next, previous, isValid, transitioning }: StepProps) => {
  const { t } = useWebTranslation();
  const error = useError();
  const isLoading = useIsLoading();
  const dispatch = useSignupDispatch();

  return (
    <ChatContainer leaving={transitioning}>
      {error && (
        <>
          <ErrorMessage>
            <Typography color="error">{formatErrorMessage(error)}</Typography>
          </ErrorMessage>
          <Gutter size={2} />
        </>
      )}
      <ChatMessage>
        <Typography>{t("signup.user_info.text_1")}</Typography>
      </ChatMessage>
      <UserInfoForm />
      <Gutter size={2} />
      <FlowButtons
        inProgress={transitioning || isLoading}
        backButton={false}
        next={() => {
          dispatch(upsertDraft(undefined, { navigateToNextOnSuccess: true }));
        }}
        disabled={!isValid}
        previous={previous}
      />
    </ChatContainer>
  );
};

export default UserInfo;
